
const menuItems = {
    snacks:[
        {
            title: 'Bagels',
            price: '$1.00',
            description: 'Soft and chewy, choose from our daily fillings ranging from cream cheese to smoked salmon.'
        },
        {
            title: 'Banana Bread',
            price: '$4.00',
            description: 'A brunch table classic, served with wildflower honey or maple syrup'
        },
        {
            title: 'French Toast',
            price: '$2.00',
            description: 'Sweet French toast made with free-range eggs and served with a selection of local marmalades'
        },
        {
            title: 'Organic Toast',
            price: '$5.00',
            description: 'The breakfast table isn’t complete with a generous serving of toast, served with an array of toppings'
        },
        {
            title: 'Eggs on Toast',
            price: '$5.00',
            description: 'Toasted bread of your choice, served with fried, boiled or poached eggs'
        },
        {
            title: 'Eggs and Bacon',
            price: '$5.00',
            description: 'Toasted bread with eggs and a generous serving of locally sourced back bacon'
        },


    ],
     coffee: [
        {
            title: "Flora's Blend",
            price: '$15.95',
            description: 'Caramelly & Rich Blend. Sweet like Butterscotch. Flavours like Red Fruit & Apricot.'
        },
        {
            title: 'Roma Espresso Blend',
            price: '$15.95',
            description: 'Strong & Bold. Sweet like Molasses. Flavours like Chocolate Milk.'
        },
        {
            title: 'Rose Decaffinated Espresso',
            price: '$16.95',
            description: 'Syrupy & Bold. Sweet like Malt Chocolate. Flavours like Real Coffee.'
        },
        {
            title: 'Blade Runner Blend',
            price: '$16.50',
            description: 'Juicy & Vibrant. Sweet like Toffee. Flavours like Tropical Fruit.'
        },
        {
            title: 'Hawai`i Ka`u Blend',
            price: '$14.00',
            description: 'Sweet like Milk Chocolate. Flavours like Strawberry & Hazelnut.'
        },
        {
            title: 'Fezenda Blend',
            price: '$13.95',
            description: 'Tastes like Green Grape and Black Tea. Sweet like Brown Sugar.'
        },
     ]
}

export { menuItems }; 